import React from "react";
const Stars = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
    >
      <g>
        <g>
          <g>
            <circle className="st0_blanco" cx="47.9" cy="13.2" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="39.7" cy="17.8" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="29.2" cy="25.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="19.9" cy="41.6" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="23.2" cy="61.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="39.9" cy="77.6" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="58" cy="80.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="76.4" cy="63.7" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="74.6" cy="46.2" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="59.6" cy="39.6" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="47.3" cy="50.6" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="50.4" cy="60.4" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="62.2" cy="63.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="76.1" cy="57.7" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="81.3" cy="41.4" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="77.6" cy="27.7" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="66.1" cy="18.1" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="49.7" cy="14.8" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="34.7" cy="17" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="17.4" cy="29.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="9.7" cy="48.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="10.4" cy="68.2" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="21.5" cy="83.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="38.6" cy="91.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="61.5" cy="90.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="78.2" cy="77.8" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="81.5" cy="49.9" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="70.7" cy="30.5" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="52" cy="26.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="36.6" cy="45.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="44.5" cy="63" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="59.3" cy="55.7" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="50.2" cy="42.6" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="43" cy="44.7" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="41.8" cy="35.5" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="49.3" cy="24.5" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="74.6" cy="40.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="67" cy="67.8" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="39.2" cy="71.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="26.6" cy="44.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="37.7" cy="24.2" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="77.4" cy="83.3" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="87.7" cy="72.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="92.7" cy="52.3" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="91.7" cy="36" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="85.7" cy="22.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="71.6" cy="12.5" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="51.9" cy="8.2" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="36.4" cy="9.1" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="24.1" cy="14.5" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="15.3" cy="22.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="10.2" cy="32.6" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="7.3" cy="47.1" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="12.4" cy="65.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="28.2" cy="80.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="48.6" cy="82.7" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="67.2" cy="69.9" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="34.5" cy="57.7" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="21.6" cy="52.1" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="25.8" cy="71.2" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="55" cy="75.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="67.9" cy="52" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="64.2" cy="25.4" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="54.4" cy="33.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="29.8" cy="32.6" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="60" cy="11.1" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="78" cy="20" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="84" cy="35.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="54.9" cy="51.5" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="35.1" cy="88.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="85.9" cy="66.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="10.4" cy="37.1" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="21.9" cy="19.6" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="71" cy="37.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="38.9" cy="49.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="45.8" cy="36.5" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="52.9" cy="69.5" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="84.8" cy="56.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="82.7" cy="42.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="84.8" cy="47.6" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="83.7" cy="49.3" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="80.3" cy="54.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="89.3" cy="40.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="89.3" cy="51.7" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="79" cy="46.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="88.8" cy="43.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="63.4" cy="21.3" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="41" cy="23" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="41.6" cy="16.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="45.7" cy="19.4" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="37.1" cy="15.3" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="43.8" cy="13.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="61.4" cy="77.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="62.6" cy="69.6" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="74.1" cy="75.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="67.1" cy="73.5" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="77.2" cy="74.7" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="68.3" cy="77.4" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="71" cy="66.6" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="73.9" cy="77.8" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="63.2" cy="71.9" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="76.6" cy="72.7" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="60.6" cy="82.9" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="75.8" cy="70.3" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="47.6" cy="47.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="37.9" cy="39.2" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="53.9" cy="42.3" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="30" cy="58.9" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="27.4" cy="32.1" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="63.9" cy="50.2" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="36.3" cy="72.2" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="27.3" cy="39.1" r="0.3" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="68" cy="46" r="0.4" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="35.3" cy="75.2" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="43.5" cy="27.4" r="0.1" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="65.5" cy="57.8" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="36.3" cy="62.6" r="0.2" />
          </g>
        </g>
        <g>
          <g>
            <circle className="st0_blanco" cx="62.4" cy="41.6" r="0.2" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Stars;



// WEBPACK FOOTER //
// ./src/components/Logo/Stars.jsx